import { render, staticRenderFns } from "./article-audit.vue?vue&type=template&id=7bea1a9a&scoped=true&"
import script from "./article-audit.vue?vue&type=script&lang=js&"
export * from "./article-audit.vue?vue&type=script&lang=js&"
import style0 from "./article-audit.vue?vue&type=style&index=0&id=7bea1a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea1a9a",
  null
  
)

export default component.exports